import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

export const AIDemoCall = () => {
  const navigate = useNavigate();
  return (
    <Section>
      <Sub>AI Demo Call (See It in Action)</Sub>
      <Desc>
        Experience the power of AI Voice Agents in a live demo. <br />
        🎙️ Schedule a quick call and see how AI can transform your business.
      </Desc>
      <Button onClick={() => navigate("/contact-us")}>Book a Demo</Button>
    </Section>
  );
};

const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 5% auto;
  gap: 20px;
  padding: 30px;
  background: linear-gradient(135deg, #e96443, #26D0CE);
  // width: 90%;
  max-width: 800px;
  border-radius: 24px;
`;

const Sub = styled.h2`
  font-family: 'Clash Grotesk', sans-serif;
  font-weight: 500;
  color: #eef1da;
  font-size: 32px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const Desc = styled.p`
  font-family: raritas, sans-serif;
  font-weight: 400;
  color: #eef1da;
  font-size: 18px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const Button = styled.button`
  background-color: #FFD700;
  color: #034C53;
  font-size: 18px;
  font-weight: 600;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
  width: 200px;
  text-align: center;

  &:hover {
    background-color: #FFC107;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    padding: 10px 20px;
  }
`;
